<template>
    <v-dialog v-model="visible" width="500">
        <template #activator="{}">
            <v-btn class="px-3 mr-2" color="primary" @click="open"> {{ dialogTitle }}</v-btn>
        </template>
        <form @submit.prevent="submit">
            <v-card>
                <FocusLock>
                    <v-card-title class="headline font-weight-bold mb-2">
                        {{ dialogTitle }}
                    </v-card-title>

                    <modal-header-notification></modal-header-notification>

                    <v-card-text class="pb-0 pt-0">
                        <v-select v-model="selectedTeilnehmer" :items="teilnehmerZugriffCreateList" :label="benutzerRolleLabel"></v-select>
                    </v-card-text>

                    <v-card-text class="pb-0 pt-0">
                        <div>
                            {{ dialogInfotext }}
                            <a :href="locale === 'fr' ? 'https://vetdata.ch/fr/pricing' : 'https://vetdata.ch/pricing/'" target="_blank">{{
                                locale === 'fr' ? 'https://vetdata.ch/fr/pricing' : 'https://vetdata.ch/pricing/'
                            }}</a>
                        </div>
                    </v-card-text>

                    <v-card-actions class="ml-4">
                        <v-btn color="primary" type="submit" variant="flat" class="modalbutton mb-3">
                            {{ $t('components.dialog.save') }}
                        </v-btn>
                        <v-btn class="modalbutton mb-3" variant="flat" @click="visible = false">
                            {{ $t('components.dialog.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </FocusLock>
            </v-card>
        </form>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator';
import { TeilnehmerZugriffApiDto, TeilnehmerZugriffCreateApiDto, TeilnehmerZugriffPostApiDto } from '@/api-schema';

import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_EINSTELLUNGEN } from '../store';
const profilModul = namespace(NAME_EINSTELLUNGEN);

import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';
const headerNotificationModul = namespace(NAME_HEADERNOTIFICATION);

import { CREATE_TEILNEHMER_ZUGRIFF, GET_ZUGRIFF_CREATE_INFO } from '../store/actions';
import { GETCREATETEILNEHMERZUGRIFFELIST, GETTEILNEHMERZUGRIFFE } from '../store/getters';
import { CLOSE_MODAL, NEW_MODAL_ERROR } from '@/store/modules/headerNotification/actions';

import modalHeaderNotification from '@/components/ModalHeaderNotification.vue';
@Component({
    components: {
        modalHeaderNotification
    }
})
export default class AddTeilnehmerZugriffDialog extends Vue {
    private visible = false;
    private selectedTeilnehmer: number;

    @Prop({ type: String, required: true })
    private dialogTitle!: string;

    @Prop({ type: String, required: true })
    private dialogInfotext!: string;

    @Prop({ type: String, required: true })
    private benutzerRolleLabel!: string;

    @Prop({ type: String, required: true })
    private teilnehmerTyp!: string;

    @profilModul.Action(CREATE_TEILNEHMER_ZUGRIFF) add!: Function;
    @profilModul.Action(GET_ZUGRIFF_CREATE_INFO) getTeilnehmerZugriffCreateInfo!: Function;
    @headerNotificationModul.Action(CLOSE_MODAL) closeHeader!: Function;
    @headerNotificationModul.Action(NEW_MODAL_ERROR) errorModal!: Function;

    @profilModul.Getter(GETCREATETEILNEHMERZUGRIFFELIST) teilnehmerZugriffCreateList!: Array<any>;
    @profilModul.Getter(GETTEILNEHMERZUGRIFFE) teilnehmerZugriffe!: Array<TeilnehmerZugriffApiDto>;

    private get locale(): string {
        return this.$i18n.locale; // Access the current locale from Vue i18n instance
    }

    private onSave() {
        const teilnehmer: TeilnehmerZugriffPostApiDto = {
            zugriffFuerTeilnehmerId: this.selectedTeilnehmer
        };
        this.add(teilnehmer).then((response) => {
            this.visible = false;
        });
    }

    private open() {
        this.closeHeader();
        this.$emit('open');
        this.getTeilnehmerZugriffCreateInfo(this.teilnehmerTyp).then(() => {
            this.selectedTeilnehmer = null;
            this.visible = true;
        });
    }

    submit() {
        const selectedTeilnehmer = this.teilnehmerZugriffCreateList.find((z) => z.value == this.selectedTeilnehmer);
        let alreadyExists = false;
        for (let i = 0; i < this.teilnehmerZugriffe.length; i++) {
            if (this.teilnehmerZugriffe[i].teilnehmerName == selectedTeilnehmer.text) {
                alreadyExists = true;
                break;
            }
        }
        if (!alreadyExists) {
            this.onSave();
        } else {
            this.errorModal({ text: this.$t('einstellungen.teilnehmerzugriff.dialog.error.duplicate') });
        }
    }
}
</script>
